module.exports = __webpack_public_path__ + "scaglie_pe@2x.jpg?47b9667378302142e23fd1fffae7e4fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scaglie_pe@2x.jpg
// module id = 253
// module chunks = 0